import { Injectable } from '@angular/core';
import { DynamicForm, Fields } from 'projects/pplus/src/lib/models/components/dynamic-form.model';
import { Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class UserGroupDetailsService {

  private readonly generalFields: Fields[] = [
    {
      name: 'userGroupId',
      type: 'text',
      placeholder: 'ID',
      value: '',
      disabled: true,
    },
    {
      name: 'name',
      type: 'text',
      placeholder: 'NOMBRE',
      value: '',
      validators: [
        Validators.required,
        Validators.maxLength(100),
      ],
    },
    {
      name: 'description',
      type: 'text',
      placeholder: 'DESCRIPCIÓN',
      value: '',
      validators: [
        Validators.required,
        Validators.maxLength(999),
      ],
    },
    {
      name: 'activated',
      type: 'checkbox',
      placeholder: 'ACTIVO',
      value: true,
    },
    {
      name: 'userIds',
      type: 'select',
      label: 'USUARIOS',
      multiple: true,
      searchName: 'usersSearch',
      value: [],
      options: [],
    },
    {
      name: 'entityId',
      type: 'select',
      label: 'ENTIDAD',
      value: [],
      validators: [
        Validators.required,
      ],
      options: [],
    },
    {
      name: 'ownerEntityId',
      type: 'select',
      label: 'ENTIDAD PROPIETARIA',
      value: [],
      validators: [
        Validators.required,
      ],
      options: [],
    },
  ];

  constructor() {}

  getDynamicForm(): DynamicForm[] {
    return [
      {
        title: 'DATOS GENERALES',
        fields: this.generalFields,
        open: true,
      },
    ];
  }

}
